import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Filter from './components/Filter';
import OperationLog from './components/OperationLog';
import LookAttachment from './components/LookAttachment';
import ProjectRequestFinish from './components/ProjectRequestFinish';
import ContractRequestFinish from './components/ContractRequestFinish';
import Update from './components/Update';
import Present from './Present';
import History from './History';
import SideNav from '../SideNav';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { saveParams } from '../../../actions/noticeActions';
import NodeModel from './components/NodeModel';
import FinanceAdjust from './components/FinanceAdjust';
import ProjectClose from './components/ProjectClose';

const DefaultSearchParams = {
    jdeContractAmountSymbol: 'Equals',
    startTimeSymbol: 'Equals',
    endTimeSymbol: 'Equals',
};

class ContractRecord extends Component {
    static childContextTypes = {
        curRole: PropTypes.string,
        levelList: PropTypes.array,
        stageList: PropTypes.array,
        businessList: PropTypes.array,
        testeeTypeList: PropTypes.array,
        typeList: PropTypes.array,
        signingUnit: PropTypes.array,
        belongingToUnit: PropTypes.array,
        contractTypeList: PropTypes.array,
        currencyList: PropTypes.array,
        areaOptions:PropTypes.array,
        adjustStatusList:PropTypes.array,
    }

    constructor(props) {
        super(props);
        const { path, investigationName, investigationJdeCode } = props;
        const searchParams = {...DefaultSearchParams};
        if (path === '/contractManagement/contractRecord') {
            searchParams.investigationName = investigationName;
            searchParams.investigationJdeCode = investigationJdeCode;
        }
        this.state = {
            searchParams,
            businessList: [],
            signingUnit: [],
            belongingToUnit: [],
            contractTypeList: [],
            testeeTypeList: [],
            levelList: [],
            stageList: [],
            typeList: [],
            areaOptions:[],
            currencyList: [],
            adjustStatusList: [],
            reload: null,
            history: false
        };
    }

    getChildContext = () => {
        const { curRole } = sessionStorage;
        const {
            levelList, stageList, businessList, testeeTypeList,
            typeList, signingUnit, belongingToUnit, contractTypeList, currencyList,
            areaOptions, adjustStatusList,
        } = this.state;
        return {
            curRole,
            levelList,
            stageList,
            businessList,
            testeeTypeList,
            typeList,
            signingUnit,
            belongingToUnit,
            contractTypeList,
            currencyList,
            areaOptions,
            adjustStatusList,
        };
    }

    componentDidMount() {
        this.loadAreaList();
        this.querySigningUnit();
        this.queryBelongingToUnit();
        this.queryWithLevelByParams();
        this.loadTypeConfigureList();
        this.loadAllCurrencyExchangeRateList();
        this.queryAdjustStatus();
        this.props.saveParams({
            path: undefined,
            investigationId: undefined,
            investigationName: undefined,
            investigationJdeCode: undefined,    
        });
    }

    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryUnitOfSigningList,
                data: {
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { datas = [] } = res;
            this.setState({ signingUnit: datas });
        });
    }

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryUnitOfBelongingList,
                data: {
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { datas = [] } = res;
            this.setState({ belongingToUnit: datas });
        });
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                levelList: res.levelList,
                typeList: res.typeList,
                stageList: res.stageList,
                testeeTypeList: res.testeeTypeList,
                contractTypeList: res.contractTypeList,
            });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadAllCurrencyExchangeRateList = () => {
        dictCache.getDict('CURRENCY_RATE_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryAllCurrencyExchangeRate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ currencyList: res.data });
        });
    }

    queryAdjustStatus = () => {
        dictCache.getDict('ADJUST_STATUS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryAdjustStatus,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { map = {} } = res;
            const datas = [];
            for (const key in map) {
                datas.push({
                    value: key,
                    label: map[key],
                })
            }
            this.setState({ adjustStatusList: datas });
        });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams });
    }
    
    reload = () => {
        this.setState({ reload: {} });
    }

    search = () => {
        const { history } = this.state;
        if (!!history) {
            this.historyRef.search();
        } else {
            this.presentRef.search();
        }
    }

    toggle = () => {
        this.setState(prevState => ({
            ...prevState,
            searchParams: {...DefaultSearchParams},
            history: !prevState.history
        }));
    }

    showLog = (record, type) => {
        this.logRef.show(record, type);
    }

    showAttachment = ( record, rowKey ) => {
        this.attachmentRef.show(record, rowKey);
    }

    applyProjectFinish = (record, role) => {
        this.projectRef.show(record, role);
    }

    applyContractFinish = (record, role) => {
        this.contractRef.show(record, role);
    }

    showProjectClose = (record, type) => {
        this.projectCloseRef.show(record, type);
    }

    showFinanceAdjust = (record, type) => {
        this.financeAdjustRef.show(record, type);
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    canUpload = value => {
        this.setState({ canUpload: value })
    }

    showNodeModel = (record, isBoTal) => {
        this.nodeModelRef.show(record, isBoTal);
    }

    goToProcessing = (target, record) => {
        const { investigationId, investigationName } = record;
        switch (target) {
            case 'CONTRACT_REMITTANCE_APPLICATION':
                this.props.saveParams({ 
                    investigationName,
                    paymentProgressIds: '8,9,10,12',
                });
                location.href = '/#/contractManagement/requestRecord';
                break;
            case 'INVESTIGATION_CONFIGURE':
                sessionStorage.curRole = 'PM';
                sessionStorage.invId = investigationId;
                sessionStorage.invName = investigationName;
                location.href = '/#/invDetails';
                break;
            case 'INVESTIGATION_COMPLETION':
                this.props.saveParams({ investigationName });
                location.href = '/#/proPercent';
                break;
        }
    }

    render() {
        const { searchParams, reload, history, canUpload = false } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='record' />
                <div className="main contract-record">
                    <Filter
                        search={this.search}
                        toggle={this.toggle}
                        update={this.update}
                        history={history}
                        canUpload={canUpload}
                        searchParams={searchParams}
                        onChange={this.handleChange}
                    />
                    {
                        !history ?
                            <Present
                                reload={reload}
                                searchParams={searchParams}
                                showLog={this.showLog}
                                canUpload={this.canUpload}
                                showNodeModel={this.showNodeModel}
                                showAttachment={this.showAttachment}
                                applyProjectFinish={this.applyProjectFinish}
                                applyContractFinish={this.applyContractFinish}
                                showProjectClose={this.showProjectClose} 
                                showFinanceAdjust={this.showFinanceAdjust}
                                goToProcessing={this.goToProcessing}
                                ref={el => this.presentRef = el}
                            />
                        :
                            <History
                                reload={reload}
                                searchParams={searchParams}
                                update={this.update}
                                ref={el => this.historyRef = el}
                            />
                    }
                    <OperationLog ref={el => this.logRef = el} />
                    <LookAttachment ref={el => this.attachmentRef = el} />
                    <Update ref={el => this.updateRef = el } loadData={this.reload} />
                    <ProjectRequestFinish ref={el => this.projectRef = el } loadData={this.reload} />
                    <ContractRequestFinish ref={el => this.contractRef = el } loadData={this.reload} />
                    <NodeModel ref={ el => this.nodeModelRef = el} loadData={this.reload} />
                    <ProjectClose ref={ el => this.projectCloseRef = el} loadData={this.reload} />
                    <FinanceAdjust ref={ el => this.financeAdjustRef = el} loadData={this.reload} />
                </div>           
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContractRecord);


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/index.js